import SystemFooter from "default/components/SystemFooter";

export default function OmagunFooter() {
  return (
    <SystemFooter
      contentLinks={[
        ["my_page", "mypage"],
        ["quests", "quests"],
        ["trials", "trials"],
        ["missions", "missions"],
        ["purchase_ticket", "tickets"],
      ]}
    />
  );
}
